import React from "react"
import { Lookup } from "../features/dashboard/Lookup";
import { PreQuoteCreateDialog } from "../features/dashboard/PreQuoteCreateDialog";
import { Stack} from '@mui/system';
import { DashboardCard } from "../../../components";
import { Button, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router";
import { useCenterFindQuery } from "../../../services/orgService/org-api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMyProfileQuery } from "../../../services/profileService/profile-api";
import { useAppDispatch } from "../../../app/hooks";
import { togglePreQuoteCreateDialog } from "../../../app/slices/VerificationModuleSlice";

function Dashboard(){
    const {center} = useParams();
    const canCreatePreQuote = center !== 'ALL';
    const profile = useMyProfileQuery();
    const selectedCenter = useCenterFindQuery(center!);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    return <React.Fragment>
        <div>
            <Stack direction='row' justifyContent='space-around' alignItems='center'>                
                <Typography color='#62BCBD' variant="h5">{selectedCenter.data?.shortName}</Typography>
                <Lookup/>
                <Stack direction='row' gap={1}>
                    {canCreatePreQuote &&
                    <Button
                        variant='outlined'
                        onClick={() => dispatch(togglePreQuoteCreateDialog())}
                        sx={{borderColor: '#9C27B0', color: '#9C27B0', '&:hover': {borderColor: '#7B1FA2', backgroundColor: 'rgba(156,39,176,0.04)'}}}
                    >
                        New Pre Quote
                    </Button>}
                    <Button variant='outlined' onClick={()=>navigate('/VerifyHome')} color='success'><FontAwesomeIcon icon={'arrow-left'}/><span className="ms-1">Go Back</span></Button>
                </Stack>
            </Stack>
            
            <Stack direction='column' justifyContent='center' alignItems='center'>
                <Typography variant='h6' color='#62BCBD' sx={{marginTop:'10px'}}>In Process</Typography>
                <Stack direction='row' gap={2} alignItems='center'>
                    <DashboardCard title="Total In Process" queryParam="In Process" center={center!}/>
                    <DashboardCard title='Benefits' queryParam="Benefits" center={center!}/>
                    <DashboardCard title='Authorization' queryParam="Authorization" center={center!}/>
                    <DashboardCard title='Financial' queryParam="Financial Orientation" center={center!}/>
                    <DashboardCard title='Awaiting Service' queryParam="Complete" center={center!}/>
                </Stack>
                <Typography variant='h6' color='#62BCBD' sx={{marginTop:'10px'}}>Needs Attention</Typography>
                <Stack direction='row' gap={2} alignItems='center'>
                    <DashboardCard title="Patient Info" queryParam="Invalid Patient" center={center!}/>
                    <DashboardCard title='Invalid Insurance' queryParam="Invalid Insurance" center={center!}/>
                    <DashboardCard title='Denied Auth' queryParam="Authorization Denied" center={center!}/>
                    <DashboardCard title='Same Day Add' queryParam="Same Day Add" center={center!}/>
                    <DashboardCard title='Low Contribution' queryParam="Low Contribution Margin" center={center!}/>
                    <DashboardCard title='Discharge Notice' queryParam="Discharge Incomplete" center={center!}/>
                </Stack>
                <Stack direction='row' gap={2} alignItems='center'>
                    <DashboardCard title='COB Issue' queryParam="COB Issue" center={center!}/>
                    <DashboardCard title='Single Case Agree.' queryParam="Single Case Agreement" center={center!}/>
                    <DashboardCard title='$0 Reimb. Cases' queryParam="Zero Reimbursement" center={center!}/>
                    <DashboardCard title='Implant Cost' queryParam="Implant Cost" center={center!}/>
                    <DashboardCard title='Facility Requests' queryParam="Escalated" center={center!}/>
                    <DashboardCard title='VOB Requests' queryParam="VobRequest" center={center!}/>
                    <DashboardCard title='Check OON Notes' queryParam="CheckOonNotes" center={center!}/>
                    <DashboardCard title='Pre Quotes' queryParam="PreQuote" center={center!} onAction={canCreatePreQuote ? () => dispatch(togglePreQuoteCreateDialog()) : undefined}/>
                </Stack>
                <Typography variant='h6' color='#62BCBD' sx={{marginTop:'10px'}}>Service Date Priority</Typography>
                <Stack direction='row' gap={2} alignItems='center'>
                    <DashboardCard title='Critical (0-72hrs)' queryParam="ServiceDate 0-72hrs" center={center!}/>
                    <DashboardCard title='High (3-7 days)' queryParam="ServiceDate 3-7days" center={center!}/>
                    <DashboardCard title='Moderate (7-14d)' queryParam="ServiceDate 7-14days" center={center!}/>
                </Stack>
                {profile.data?.claimsAccess.find((p) => p.code === "AdecAudit") &&
                <div>
                    <Typography variant='h6' color='#62BCBD' sx={{marginTop:'10px', textAlign:'center'}}>Adec</Typography>
                    <Stack direction='row' gap={2} alignItems='center'>
                        <DashboardCard title='Adec Worklist' queryParam="AdecBenefits" center={center!} outsourced = {true}/>
                        <DashboardCard title='Assistance Request' queryParam="Assistance Needed" center={center!}/>
                    </Stack>
                </div>}
                {profile.data?.claimsAccess.find((p) => p.code === "VobManager") &&
                <div>
                    <Typography variant='h6' color='#62BCBD' sx={{marginTop:'10px', textAlign:'center'}}>Management</Typography>
                    <Stack direction='row' gap={2} alignItems='center' justifyContent='center'>
                        <DashboardCard title='Self Pay Review' queryParam="Self Pay Review" center={center!}/>
                        <DashboardCard title='Implant Variance' queryParam="Implant Variance" center={center!}/>
                    </Stack>
                </div>}
                {profile.data?.claimsAccess.find((p) => p.code==='VascularCases') !== undefined &&
                <div>
                    <Typography variant='h6' color='#62BCBD' sx={{marginTop:'10px', textAlign:'center'}}>Vascular</Typography>
                    <Stack direction='row' gap={2} alignItems='center'>
                        <DashboardCard title='Benefits' queryParam="Vascular Benefits" center={center!} outsourced = {true}/>
                        <DashboardCard title='Authorization' queryParam="Vascular Authorization" center={center!}/>
                    </Stack>
                </div>}
            </Stack>
            <br/>

            {canCreatePreQuote && <PreQuoteCreateDialog/>}
        </div>
    </React.Fragment>
}

export {Dashboard}